import { useEffect, useState } from 'react';
import api from '../../services/api';
import AdminLayout from '../../layouts/AdminLayout';
import Button from '../../components/common/Button';

const TYPE_COLORS = {
  verification: 'bg-blue-100 text-blue-700',
  payment:      'bg-green-100 text-green-700',
  match:        'bg-brand-100 text-brand-700',
  announcement: 'bg-purple-100 text-purple-700',
};

export default function AdminNotifications() {
  const [notifications, setNotifications] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);

  useEffect(() => {
    setLoading(true);
    api.get(`/admin/notifications?page=${page}&limit=30`).then((r) => {
      setNotifications(r.data.data);
      setPagination(r.data.pagination);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [page]);

  return (
    <AdminLayout>
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <h1 className="text-xl font-bold text-gray-900">Notifications</h1>
          <span className="text-sm text-gray-500">{pagination.total?.toLocaleString()} total</span>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                {['Mobile', 'Type', 'Title', 'Body', 'Read', 'Sent At'].map((h) => (
                  <th key={h} className="px-4 py-3 text-left text-xs font-semibold text-gray-500 uppercase">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr><td colSpan={6} className="py-12 text-center text-gray-400">Loading...</td></tr>
              ) : notifications.length === 0 ? (
                <tr><td colSpan={6} className="py-12 text-center text-gray-400">No notifications</td></tr>
              ) : notifications.map((n) => (
                <tr key={n.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-gray-600">{n.mobile}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${TYPE_COLORS[n.type] || 'bg-gray-100 text-gray-600'}`}>
                      {n.type}
                    </span>
                  </td>
                  <td className="px-4 py-3 font-medium text-gray-800">{n.title}</td>
                  <td className="px-4 py-3 text-gray-500 max-w-xs truncate">{n.body}</td>
                  <td className="px-4 py-3 text-center">
                    {n.read_at ? <span className="text-green-500 text-xs">✓</span> : <span className="text-gray-300 text-xs">○</span>}
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">
                    {new Date(n.created_at).toLocaleString('en-IN')}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          {pagination.totalPages > 1 && (
            <div className="border-t border-gray-200 px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-gray-500">Page {pagination.page} of {pagination.totalPages}</span>
              <div className="flex gap-2">
                {pagination.hasPrev && <Button size="sm" variant="secondary" onClick={() => setPage(p => p - 1)}>← Prev</Button>}
                {pagination.hasNext && <Button size="sm" variant="secondary" onClick={() => setPage(p => p + 1)}>Next →</Button>}
              </div>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
